import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.jsx';
import './styles/tokens.css';

const root = document.getElementById('root');

// Static pages are prerendered at build time, so hydrate rather than replace
// when there is existing markup — otherwise the first paint flashes empty.
const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Only real markup counts. In dev (and in any unprerendered page) #root holds
// just the `<!--affily:body-->` marker comment, which hasChildNodes() treats as
// content and sends React down the hydration path to a guaranteed mismatch.
if (root.firstElementChild) {
  ReactDOM.hydrateRoot(root, tree);
} else {
  ReactDOM.createRoot(root).render(tree);
}
